import React from 'react'
import { Button } from '@livechat/design-system-react-components'
import { css } from '@emotion/react'

import auth from '@/utils/auth'

const buttonCss = css`
  font-size: 16px;
  min-width: 96px;
`

const LogInButton = () => {
  return (
    <Button css={buttonCss} onClick={() => auth.signIn()} kind="secondary">
      Log in
    </Button>
  )
}

export default LogInButton
